import React from "react";
import QPhototModuleSubtopic from "../../../QPhotoModuleSubtopic";

const Jacobian = () => (
  <QPhototModuleSubtopic
    title="jacobian"
    videos={[
      "https://www.youtube.com/embed/Th_oKIMl94Q",
      "https://www.youtube.com/embed/Avvclgk7n6Y",
      "https://www.youtube.com/embed/2u7WTaICmQc"
    ]}
    takeaways={[]}
    questions={[
        {
            image:"/cal_23.jpeg"
        },
        {
            image:"/cal_24.jpeg"
        },
        {
            image:"/cal_25.jpeg"
        },
        {
            image:"/cal_26.jpeg"
        }
    ]}
    exampleVideos={[]}
  />
);

export default Jacobian;
